/**
 * Remote join codes match the Durable Object allocator (no 0/1/I/O).
 * @see functions/remote-api and workers/deck-pack-remote-room randomRoomId
 */
export const REMOTE_ROOM_CODE_RE = /^[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{4,12}$/i;

export function normalizeRemoteRoomCode(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw.replace(/[^A-Za-z0-9]/g, '').slice(0, 12).toUpperCase();
}

export function isValidRemoteRoomCode(s) {
  return typeof s === 'string' && s.length >= 4 && REMOTE_ROOM_CODE_RE.test(s);
}

/** Full join URL for the short path `/{roomId}` (no /remote?room=). */
export function buildRemoteJoinUrl(origin, roomId) {
  const base = (origin || '').replace(/\/$/, '');
  const id = normalizeRemoteRoomCode(roomId);
  if (!id) return '';
  return `${base}/${id}`;
}
